import Loading from './components/Loading';
import LoadingProgress from './components/LoadingProgress';
import Header from './components/Header';
import MapLayout from './components/map/MapLayout';
import ToastContainer from './components/ToastContainer';
import OverlayRoot from './components/OverlayRoot';
import Maintenance from './components/Maintenance';

import AppRoutes from './AppRoutes';

import { useProfilesSync } from './hooks/auth/useProfilesSync';
import { useFullscreen } from './hooks/screen/useFullscreen';
import { useFullscreenListener } from './hooks/screen/useFullscreenListener';
import { useFullscreenChannel } from './hooks/screen/useFullscreenChannel';
import { useThemeChannel } from './hooks/theme/useThemeChannel';
import { useOverlay } from './hooks/overlay/useOverlay';
import { useHashsSync } from './hooks/hashs/useHashsSync';

import { Box } from '@mui/material';

// =========================
// CONFIG
// =========================

const MAINTENANCE_MODE = false;

// =========================
// MAIN APP
// =========================

function MainApp() {

  useHashsSync();
  useProfilesSync();
  useFullscreen();
  useFullscreenListener();
  useFullscreenChannel();
  useThemeChannel();
  useOverlay();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh'
      }}
    >
      <LoadingProgress />
      <Loading />
      <ToastContainer />
      <Header />
      <MapLayout />
      <OverlayRoot />
      <AppRoutes />
    </Box>
  );
}

// =========================
// APP
// =========================

export default function App() {

  if (MAINTENANCE_MODE) {
    document.title = `Manutenção`;
    return <Maintenance />;
  }

  return <MainApp />;
}